import { render } from "./BurgerMenuIcon.vue?vue&type=template&id=0f02f216"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=js"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__